import { useResetFilter, useResetFilters } from "../components/elements/SearchResults/components/boundsFilterHooks.js";
import flights_funnel_layover_price_airport_filter_web from "../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
export const useFiltersReset = () => {
    const _resetFilter = useResetFilter();
    const resetFilters = useResetFilters();
    const resetFilter = (filters) => {
        filters.forEach((filter) => _resetFilter(filter));
        flights_funnel_layover_price_airport_filter_web.goals.deselect();
    };
    const resetAllFilters = () => {
        resetFilters();
        flights_funnel_layover_price_airport_filter_web.goals.reset();
    };
    return {
        resetFilter,
        resetAllFilters
    };
};
